import { render } from "./language-settings-web.vue?vue&type=template&id=cacd3312"
import script from "./language-settings-web.vue?vue&type=script&lang=js"
export * from "./language-settings-web.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__